<template>
    <employment-doc-body
        v-model="form.fields"
        v-bind="{
            mode,
            pages,
        }"
        withoutReset
    />
</template>

<script>
import { initEmploymentForm } from "@/assets/variables";

import EmploymentDocBody from "@/components/console/employment/doc/employment-doc-body.vue";

export default {
    components: {
        EmploymentDocBody,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "view" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
    }),
    computed: {
        pages() {
            return this.form?.pages;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
    },
};
</script>

<style></style>
